import { DegreeLevelPayload, Offset } from '@uc/web/shared/data-models';
import {
	CourseSearchPayload,
	CourseStudyMode,
	UniversityCourseSearchPayload,
	UniversityRegion,
} from '../models/course-search-payload.models';
import {
	STUDY_MODE_TYPE_MAPPER,
	UNIVERSITY_REGION_TYPE_MAPPER,
} from '../static/course-search-payload.properties';
import { DEGREE_LEVEL_TYPE_MAPPER, MAX_UCAS_TARIFF } from '@uc/web/shared/data-access';
import { Product } from '@uc/shared/data-models';

export const mapParamsToPayload = (
	degree: string,
	location: string | undefined,
	mode: string | undefined,
	ucaspts: string | undefined,
	searchTerm: string | undefined,
	page: string | undefined,
) => {
	const [min = 0, max = MAX_UCAS_TARIFF] = ucaspts?.split('_') ?? [];
	const degreeLevel = getDegreeLevelType(degree);
	const region = getUniversityRegionType(location) || null;
	const studyMode = getStudyModeType(mode) || null;
	const formattedSearchTerm = searchTerm?.replace(/-/g, ' ') ?? '';

	return {
		degreeLevel,
		tariffMin: Number(min),
		tariffMax: Number(max),
		region,
		studyMode,
		name: formattedSearchTerm,
		page: Number(page) || 1,
		offset: Number(page) > 1 ? Offset.Off : Offset.On,
	};
};

export const getUniSearchFilterResetPayload = (slug: string, studyLevel: Product) => {
	const payload: Partial<UniversityCourseSearchPayload> = {
		slug,
		degreeLevel: getDegreeLevelType(studyLevel),
		tariffMin: 0,
		tariffMax: MAX_UCAS_TARIFF,
		studyMode: null,
		name: null,
		page: 1,
		offset: Offset.On,
	};
	return payload;
};

export const getSearchFilterResetPayload = (subject: string, studyLevel: Product) => {
	const payload: Partial<CourseSearchPayload> = {
		degreeLevel: getDegreeLevelType(studyLevel),
		tariffMin: 0,
		tariffMax: MAX_UCAS_TARIFF,
		studyMode: null,
		name: subject,
		region: null,
		page: 1,
		offset: Offset.On,
	};
	return payload;
};

export const getDegreeLevelType = (degree: string) => {
	return DEGREE_LEVEL_TYPE_MAPPER[
		degree as keyof typeof DEGREE_LEVEL_TYPE_MAPPER
	] as DegreeLevelPayload;
};

export const getDegreeLevelKeyByType = (degreeLevel: DegreeLevelPayload) => {
	return Object.keys(DEGREE_LEVEL_TYPE_MAPPER).find(
		(key) =>
			DEGREE_LEVEL_TYPE_MAPPER[key as keyof typeof DEGREE_LEVEL_TYPE_MAPPER] ===
			degreeLevel,
	) as keyof typeof DEGREE_LEVEL_TYPE_MAPPER;
};

export const getUniversityRegionType = (location: string | undefined) => {
	return UNIVERSITY_REGION_TYPE_MAPPER[
		location as keyof typeof UNIVERSITY_REGION_TYPE_MAPPER
	] as UniversityRegion;
};

export const getStudyModeType = (mode: string | undefined) => {
	return STUDY_MODE_TYPE_MAPPER[
		mode as keyof typeof STUDY_MODE_TYPE_MAPPER
	] as CourseStudyMode;
};
